import ContentCard from "../../ui/ContentCard";
import ContentCardTitle from "../../ui/ContentCardTitle";
import styles from "../../styles/Components/exchange-portfolio/ExchangePortfolioInfo.module.css";
import { FaTableList } from "react-icons/fa6";
import { TbChartPieFilled } from "react-icons/tb";
import ExchangePortfolioCharts from "./ExchangePortfolioCharts";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useRef, useState } from "react";
import { setSelectedPortfolioExchange } from "../../redux/exchange/actions";
import ExchangePortfolioTable from "./ExchangePortfolioTable";
import IntegratedExchangesDropdown from "./IntegratedExchangesDropdown";
import ExchangeBalanceInfo from "./ExchangeBalanceInfo";

function ExchangePortfolioInfo() {
  const {
    exchangeState: { selectedPortfolioExchange },
    main: { userData },
    profile: { profileData },
  } = useSelector((state) => state);

  const demoExchange = "cryptocrispy";

  const username = userData?.["custom:custom_username"];
  const email = userData?.["cognito:username"];

  const [viewMode, setViewMode] = useState("chart");

  const dispatch = useDispatch();

  const controllerRef = useRef(null);

  const selectDemoExchange = () => {
    dispatch(setSelectedPortfolioExchange(demoExchange, username, email));
  };

  useEffect(() => {
    if (!selectedPortfolioExchange && email) {
      if (profileData?.bot_active_exchange) {
        dispatch(
          setSelectedPortfolioExchange(
            profileData?.bot_active_exchange,
            username,
            email,
          ),
        );
      } else {
        selectDemoExchange();
      }
    }
  }, [
    email,
    selectDemoExchange,
    selectedPortfolioExchange,
    profileData?.bot_active_exchange,
    dispatch,
    username,
  ]);

  return (
    <ContentCard>
      <div className={styles.header}>
        <div className={styles.headerLeft}>
          <ContentCardTitle title="My Portfolio" />
          <div className={styles.exchangeOptions}>
            <div
              className={`${styles.exchangeOption} ${selectedPortfolioExchange === demoExchange ? styles.selectedOption : ""}`}
              onClick={selectDemoExchange}
            >
              Demo Exchange
            </div>
            <IntegratedExchangesDropdown
              className={`${styles.exchangeOption} ${selectedPortfolioExchange !== demoExchange ? styles.selectedOption : ""}`}
              title="Real Exchanges"
              controller={controllerRef.current}
            />
          </div>
        </div>
        <div className={styles.viewOptions}>
          <span
            className={`${styles.viewOption} ${viewMode === "chart" ? styles.selectedOption : ""}`}
            onClick={() => setViewMode("chart")}
          >
            <TbChartPieFilled /> Portfolio Chart
          </span>
          <span
            className={`${styles.viewOption} ${viewMode === "table" ? styles.selectedOption : ""}`}
            onClick={() => setViewMode("table")}
          >
            <FaTableList />
            Portfolio Table
          </span>
        </div>
      </div>

      <ExchangeBalanceInfo />

      {viewMode === "chart" && <ExchangePortfolioCharts />}
      {viewMode === "table" && <ExchangePortfolioTable />}
    </ContentCard>
  );
}

export default ExchangePortfolioInfo;
